import { Component, OnInit } from '@angular/core';
import {IndisponibilidadeService} from '../indisponibilidade.service';
import {ConfirmacaoService, MensagemService, ProgressoService, Restricao, RestricaoOperador, RestricaoPadrao, Restricoes} from 'maestro-ng';
import {ActivatedRoute, Router} from '@angular/router';
import {Indisponibilidade} from '../indisponibilidade.model';
import {DataSourceRouted} from '../../util/data-source-routed';
import {AutenticacaoService} from '../../autenticacao/autenticacao.service';
import {SelectItem} from 'primeng/api';
import {SelectItemService} from '../../services/select-item.service';

@Component({
  selector: 'app-indisponibilidade-lista',
  templateUrl: './indisponibilidade-lista.component.html',
  styleUrls: ['./indisponibilidade-lista.component.css']
})
export class IndisponibilidadeListaComponent implements OnInit {
  public ds: DataSourceRouted<Indisponibilidade, number>;

  public permissaoIndisponibilidade = false;
  public expandedRows: { [s: string]: boolean } = {};
  public allRowsExpanded = false;

  public indisponibilidadeTipoItens: SelectItem[];
  public simNaoItens: SelectItem[];

  constructor(
    private service: IndisponibilidadeService,
    private progressoService: ProgressoService,
    private mensagemService: MensagemService,
    private autenticacaoService: AutenticacaoService,
    private confirmacaoService: ConfirmacaoService,
    private selectItemService: SelectItemService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.ds = new DataSourceRouted<Indisponibilidade, number>(
      'indisponibilidade-lista',
      (c) => this.service.recuperarPaginado(c),
      this.mensagemService, this.progressoService,
      this.route,
      this.router,
      15,
      new Restricoes(
        [
          new Restricao<number>({ atributo: 'id', operador: RestricaoOperador.EQUALS }),
          new Restricao<Date>({ atributo: 'dataInicio', operador: RestricaoOperador.LE, padrao: RestricaoPadrao.DATE }),
          new Restricao<Date>({ atributo: 'dataFim', operador: RestricaoOperador.LE, padrao: RestricaoPadrao.DATE }),
          new Restricao<string>({ atributo: 'descricao', operador: RestricaoOperador.CONTAINS }),
          new Restricao<string>({ atributo: 'tipo', operador: RestricaoOperador.EQUALS }),
          new Restricao<string>({ atributo: 'suspendePrazos', operador: RestricaoOperador.EQUALS })
        ]
      )
    );
  }

  ngOnInit(): void {
    this.permissaoIndisponibilidade = this.autenticacaoService.temPermissaoExecucao('rest/indisponibilidade');
    this.indisponibilidadeTipoItens = this.selectItemService.getTipoIndisponibilidade();
    this.simNaoItens = this.selectItemService.getSimNaoItens();
  }

  iniciarExclusao(indisponibilidade: Indisponibilidade): void {
    this.confirmacaoService.confirmar({
      mensagem: 'Você tem certeza que deseja excluir a indisponibilidade ?',
      aceitar: () => {
        this.service.excluir(indisponibilidade)
          .then(() => {
            this.ds.atualizar();
          })
          .catch(response => {
            this.mensagemService.addErro('Erro ao excluir dados da indisponibilidade!', response.error);
          });
      }
    });
  }

  toggleExpandAll(): void {
    this.allRowsExpanded = !this.allRowsExpanded;
    if (this.allRowsExpanded) {
      this.ds.entidades.forEach(entidade => {
        this.expandedRows[entidade.id] = true;
      });
    }
    else {
      this.expandedRows = {};
    }
  }
}
